import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import diagnosesResource from 'resources/diagnosesResource';

export enum DiagnosesStatus {
  Resolved = 'resolved',
  Error = 'error',
  NoData = 'no-data',
  Idle = 'idle',
  Loading = 'loading',
}

export default function useDiagnosesSearch({ searchTerm = '', type = 'icd9' } = {}) {
  const [diagnoses, setDiagnoses] = useState({ status: DiagnosesStatus.Idle, data: [] });
  const dispatch = useDispatch();

  useEffect(() => {
    if (searchTerm) {
      setDiagnoses({ status: DiagnosesStatus.Loading, data: [] });
      dispatch(
        diagnosesResource.request({
          url: `/diagnoses/icd/search`,
          params: {
            s: searchTerm,
            icdType: `${type.replace('Code', '')}`,
          },
          meta: {
            callbackSuccess: ({ data }) => {
              const resultData = data.map((code: any) => code.code);
              const isResultDataEmpty = isEmpty(resultData);
              setDiagnoses({
                status: isResultDataEmpty ? DiagnosesStatus.NoData : DiagnosesStatus.Resolved,
                data: resultData,
              });
            },
            callbackError: () => setDiagnoses({ status: DiagnosesStatus.Error, data: [] }),
          },
        }),
      );
    } else {
      setDiagnoses({ status: DiagnosesStatus.Idle, data: [] });
    }
  }, [dispatch, searchTerm, type]);

  return diagnoses;
}
